var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    className: "bi bi-trash",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    stroke: "null",
    id: "svg_1",
    d: "m5.5,5.5a0.5,0.5 0 0 1 0.5,0.5l0,6a0.5,0.5 0 0 1 -1,0l0,-6a0.5,0.5 0 0 1 0.5,-0.5zm2.5,0a0.5,0.5 0 0 1 0.5,0.5l0,6a0.5,0.5 0 0 1 -1,0l0,-6a0.5,0.5 0 0 1 0.5,-0.5zm3,0.5a0.5,0.5 0 0 0 -1,0l0,6a0.5,0.5 0 0 0 1,0l0,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    id: "svg_2",
    d: "m14.5,2.875a1,1 0 0 1 -1,1l-0.5,0l0,9a2,2 0 0 1 -2,2l-6,0a2,2 0 0 1 -2,-2l0,-9l-0.5,0a1,1 0 0 1 -1,-1l0,-1a1,1 0 0 1 1,-1l3.5,0a1,1 0 0 1 1,-1l2,0a1,1 0 0 1 1,1l3.5,0a1,1 0 0 1 1,1l0,1zm-10.382,1l-0.118,0.059l0,8.941a1,1 0 0 0 1,1l6,0a1,1 0 0 0 1,-1l0,-8.941l-0.118,-0.059l-7.764,0zm-1.618,-1l0,-1l11,0l0,1l-11,0z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5d9d9251373f4d1122bfde755bfd6e6c.svg";
export { ForwardRef as ReactComponent };